import { type UpdateSecondaryCategoryInputData } from '../types/UpdateSecondaryCategoryInputData'
import { type UpdateSecondaryCategoryPayload } from '../types/UpdateSecondaryCategoryPayload'

/**
 * Maps input data to the update secondary category API payload format.
 * This transformation is data access logic that converts camelCase to snake_case
 * as required by the API.
 *
 * @param inputData - Domain-level input data
 * @returns Payload formatted for the update API endpoint
 */
export const mapUpdateSecondaryCategoryInputDataToPayload = (
  inputData: UpdateSecondaryCategoryInputData
): UpdateSecondaryCategoryPayload => {
  return {
    name: inputData.name,
    branch: inputData.primaryCategoryId,
    external_id: inputData.externalId,
    punchout_email: inputData.punchoutEmail,
  }
}
